import CountdownUtils from '../../components/fsUtils/CountdownClockUtils';

class MlbamMenuHandler {
    constructor() {
        this.mlbamPlayer = document.querySelector('.mlbam-player');
        this.playerMenu = document.querySelector('.live-stream-container .player-menu');
        this.lsBody = document.querySelector('.live-stream-container .ls-body');
        this.playerMenuBtn = document.querySelector('.player-menu .menu-btn');
        this.playerStreamInfo = document.querySelector('.player-menu .stream-info');
        this.playerMenuOpenDiv = document.querySelector('.player-menu .menu-open');
        this.bonusCoverage = document.querySelector('.bonus-coverage');
        this.streamLinks = document.querySelectorAll('.bonus-coverage .stream-list');
        this.preContent = document.querySelector('.live-stream-container .pre-content');
        this.streamChannelText = document.querySelector('.stream-info .channel-desc');
        this.streamDescText = document.querySelector('.stream-info .desc');
        this.playerIsActive = false;
        this.addEventListeners();


    }
    addEventListeners() {
        this.addLinksListener();
        this.openMenuListener();
        this.addMouseOverListener();
        this.addMouseOutListener();
    }

    //Adds the mouse over listener for the player menu overlay
    addMouseOverListener() {
        if (this.mlbamPlayer) {
            this.mlbamPlayer.addEventListener('mouseover', () => {
                let noflash = false;
                if (this.bamVideoEmbed) {
                    noflash = this.bamVideoEmbed.classList.contains('no-flash');
                }
                if (!this.playerMenu.classList.contains('active') && !noflash) this.playerMenu.classList.add('active');
            }, this);
        }
    }

    //Adds the mouse out listener for the player menu overlay
    addMouseOutListener() {
        if (this.mlbamPlayer && this.lsBody) {
            this.mlbamPlayer.addEventListener('mouseout', () => {
                let classList = this.playerMenu.classList;
                if (classList.contains('active') && !this.lsBody.classList.contains('menu-open')) {
                    classList.remove('active');
                }
            }, this);
        }
    }

    //handle opening and close of the menu
    openMenuListener() {
        if (this.playerMenuBtn && this.playerStreamInfo && this.lsBody) {
            this.playerMenuBtn.addEventListener('click', () => {
                let classList = this.lsBody.classList;
                if (classList.contains('menu-open')) {
                    classList.remove('menu-open');
                } else {
                    classList.add('menu-open');
                }
            }, this);
        }
    }

    //adds the listener for the stream links avaiable 
    addLinksListener() {
        if (this.streamLinks) {
            for (let i = 0, l = this.streamLinks.length; i < l; i++) {
                let link = this.streamLinks[i];
                link.addEventListener('click', (e) => {
                    (e.preventDefault) ? e.preventDefault(): (e.returnValue = false); //ie support

                    if (link.classList.contains('live') && !link.classList.contains('now-playing')) {
                        //handle bonus coverage layout
                        if (!this.bonusCoverage.classList.contains('menu-layout')) {
                            this.bonusCoverage.classList.add('menu-layout');
                        }


                        //load video stream
                        let streamLink = link.querySelector('.stream-link');
                        let streamUrl = streamLink.getAttribute('stream-url');

                        this.loadVideoStrem(streamUrl);
                        if (this.lsBody.classList.contains('menu-open')) {
                            this.resetPlayerMenu();
                        }

                        this.handleNowPlaying(link);
                        this.updateCurrentStreamInfo(link);
                        this.playerIsActive = true;
                    }
                });

                /*  Timer for the streams to change the state to the bonus feeds dynamically */
                let linkStatus = link.querySelector('.status');
                let startTime = link.getAttribute('start-time');
                let endTime = link.getAttribute('end-time');
                let timeObj = new Date();

                let thumbnail = link.querySelector('.stream-thumbnail');

                let timeInterval = setInterval(() => {

                    let timeToStart = CountdownUtils.getTimeRemaining(startTime, 'is-hourly');
                    timeToStart = timeToStart.hours + ':' + timeToStart.minutes + ':' + timeToStart.seconds;
                    let timeToEnd = CountdownUtils.getTimeRemaining(endTime, 'is-hourly');
                    timeToEnd = timeToEnd.hours + ':' + timeToEnd.minutes + ':' + timeToEnd.seconds;

                    link.setAttribute('time-to-start', timeToStart);
                    link.setAttribute('time-to-finish', timeToEnd);
                    if (!link.classList.contains('live') && !link.classList.contains('concluded') && '0:0:0' === timeToStart) {
                        link.classList.remove('disabled');
                        link.classList.add('live');
                        linkStatus.innerText = '';
                    } else if ('0:0:0' === timeToEnd) {
                        link.classList.remove('live');
                        link.classList.remove('now-playing');
                        link.classList.add('concluded');
                        linkStatus.innerText = 'Concluded';
                        clearInterval(timeInterval);
                    }

                }, 1000);

                /** End of Timer for bonus streams **/
            }
        }
    }

    //resets the player to non open state
    resetPlayerMenu() {
        this.lsBody.classList.remove('menu-open');
    }

    //create the Mlbam player div with the needed attributes 
    createMlbamPlayerDiv(streamUrl) {
        let videoEl = document.createElement('div');
        videoEl.setAttribute('class', 'video-embed mlbam-video');
        videoEl.setAttribute('hide-mobile', 'hide');
        videoEl.setAttribute('data-video', streamUrl);

        return videoEl;
    }

    //transitions from the landing page to the mlbam player 
    toggleInitialStateOfPlayer() {
        if (this.preContent) {
            let preContentClassList = this.preContent.classList;
            if (preContentClassList.contains('active')) {
                preContentClassList.remove('active');
                this.mlbamPlayer.classList.add('active');
                this.bamVideoEmbed = document.querySelector('.live-stream-container .video-embed');
            }
        }
    }

    //handles Now Playing and 
    handleNowPlaying(link) {
        //look for the matching stream the user clicked on first, click and add the playing tag
        let playingStream = document.querySelector('.stream-list.now-playing');
        let status = link.querySelector('.status');
        if (playingStream) {
            playingStream.classList.remove('now-playing');
            let streamStatus = playingStream.querySelector('.status');
            if (streamStatus) {
                streamStatus.innerText = "";
            }

        }
        if (status) {
            if (!link.classList.contains('now-playing')) {
                link.classList.add('now-playing');
                status.innerText = "NOW PLAYING";
            }
        }
    }

    //update stream information when the menu is closed
    updateCurrentStreamInfo(link) {
        this.streamChannelText.innerText = link.querySelector('.channel-desc').innerText;
        this.streamDescText.innerText = link.querySelector('.desc').innerText;
    }

    //loads the mlbam player
    loadVideoStrem(streamUrl) {
        let videoEmbed = document.querySelector('.video-embed.mlbam-video');
        if (videoEmbed) {
            this.mlbamPlayer.removeChild(videoEmbed);
        }
        this.mlbamPlayer.appendChild(this.createMlbamPlayerDiv(streamUrl));
        window.mlbamPlayer.findAndLoadVideos();
        this.toggleInitialStateOfPlayer();
    }
}

export default MlbamMenuHandler;


// WEBPACK FOOTER //
// ./assets/components/mlbamPlayer/MlbamMenuHandler.js